/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { StorageLocation } from './StorageLocation';
import {
    StorageLocationFromJSON,
    StorageLocationFromJSONTyped,
    StorageLocationToJSON,
} from './StorageLocation';

/**
 * 
 * @export
 * @interface NullableOneOfPropertyOfStorageLocationOptions
 */
export interface NullableOneOfPropertyOfStorageLocationOptions {
    [key: string]: StorageLocation | any;
    /**
     * 
     * @type {string}
     * @memberof NullableOneOfPropertyOfStorageLocationOptions
     */
    $type?: NullableOneOfPropertyOfStorageLocationOptionsTypeEnum;
}


/**
 * @export
 */
export const NullableOneOfPropertyOfStorageLocationOptionsTypeEnum = {
    SystemCollectionsGenericDictionary2SystemStringSystemPrivateCoreLibPtwDomainItemTypeCatalogMedicalSystemsEnumsStorageLocationPtwDomainItemTypeCatalogMedicalSystemsSystemPrivateCoreLib: 'System.Collections.Generic.Dictionary`2[[System.String, System.Private.CoreLib],[Ptw.DomainItemTypeCatalog.MedicalSystems.Enums.StorageLocation, Ptw.DomainItemTypeCatalog.MedicalSystems]], System.Private.CoreLib'
} as const;
export type NullableOneOfPropertyOfStorageLocationOptionsTypeEnum = typeof NullableOneOfPropertyOfStorageLocationOptionsTypeEnum[keyof typeof NullableOneOfPropertyOfStorageLocationOptionsTypeEnum];



/**
 * Check if a given object implements the NullableOneOfPropertyOfStorageLocationOptions interface.
 */
export function instanceOfNullableOneOfPropertyOfStorageLocationOptions(value?: unknown): value is NullableOneOfPropertyOfStorageLocationOptions {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NullableOneOfPropertyOfStorageLocationOptionsTypeEnum)[0];
}

export function NullableOneOfPropertyOfStorageLocationOptionsFromJSON(json: any): NullableOneOfPropertyOfStorageLocationOptions {
    return NullableOneOfPropertyOfStorageLocationOptionsFromJSONTyped(json, false);
}

export function NullableOneOfPropertyOfStorageLocationOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NullableOneOfPropertyOfStorageLocationOptions {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function NullableOneOfPropertyOfStorageLocationOptionsToJSON(value?: NullableOneOfPropertyOfStorageLocationOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
            ...value,
        '$type': value['$type'],
    });
}

